import React, { useEffect, useState } from 'react'
import {
  Button,
  FormControl,
  Input,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  Box,
  Paper,
  Alert,
  AlertTitle
} from '@mui/material'
import InfoIcon from '@mui/icons-material/Info';
import { useDispatch, useSelector } from 'react-redux'
import {
  getSignBranches,
  getSignDocuments,
  postSignDocuments,
  postPickupBranch,
} from './store'
import SignDocumentPreview from '../../Components/SignDocumentPreviw/SignDocumentPreview'
import { useNavigate } from 'react-router-dom'

const SignDocuments = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [allDocumentsDownload, setAllDocumentsDownload] = useState(false)
  const [name, setName] = useState('')
  const [selectedBranch, setSelectedBranch] = useState('')

  const { documents, branches, pending } = useSelector(
    (state) => state.ccSignDocuments
  )

  useEffect(() => {
    dispatch(getSignDocuments())
  }, [dispatch])

  const handleContinue = async () => {
    try {
      const signResult = await dispatch(postSignDocuments({ signingName: name })).finally(() => navigate('/credit-card/standing-order'))
      console.log('Documents signed successfully:', signResult)
    } catch (error) {
      console.error('Error processing steps:', error)
    }
  }

  return (
    <div style={{ marginBottom: '10rem' }}>
      {documents?.documents?.length > 0 &&
      documents?.documents[0]?.hasClientSigned === true ? (
        <div
          style={{
            background: '#fff',
            padding: '20px 15px',
            boxShadow: '3px 4px 8px rgba(0,0,0,0.25)'
          }}
        >
          <Typography>
            Your document has been signed and is waiting for approval.
          </Typography>
        </div>
      ) : (
        <div
          style={{
            background: '#fff',
            padding: '20px 15px',
            boxShadow: '3px 4px 8px rgba(0,0,0,0.25)'
          }}
        >
          <Typography>
            Congratulations, your credit card has been approved. You can sign
            all the required documents electronically.
          </Typography>
          <SignDocumentPreview
            applications={documents?.documents || []}
            onAllDownload={() => setAllDocumentsDownload(true)}
          />
          {allDocumentsDownload ? (
            <>
              <div style={{ margin: '45px 0' }}>
                <InputLabel>Please enter your full name</InputLabel>
                <Input
                  placeholder='Full Name'
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  style={{
                    border: '0.5px solid rgba(0, 0, 0, 0.48)',
                    borderRadius: 3,
                    padding: '0px 14px',
                    width: '50%'
                  }}
                />
              </div>
              <Alert
                severity="info"
                icon={<InfoIcon fontSize="inherit" />}
                style={{
                  margin: '45px 0',
                  backgroundColor: '#E3F2FD',
                  border: '1px solid #90CAF9',
                  borderRadius: '8px'
                }}
              >
                <AlertTitle><strong>Important Information</strong></AlertTitle>
                <Typography variant="body2" style={{ color: '#0D47A1' }}>
                  Your credit card will be sent to the address we have on record.
                  Upon receipt, please activate your card and create your PIN via digital banking.
                </Typography>
              </Alert>
              <div style={{ margin: '45px 0' }}></div>
              <Button
                style={{
                  width: '255px',
                  backgroundColor: '#005FAA',
                  borderRadius: '2rem'
                }}
                variant='contained'
                onClick={handleContinue}
              >
                Continue
              </Button>
            </>
          ) : (
            <InputLabel>Download all your documents to continue</InputLabel>
          )}
        </div>
      )}
    </div>
  )
}

export default SignDocuments
